<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<!-- <lcsj-filter more-text="更多筛选" @search="inputChange()">
			<template #actions><el-button size="small" type="primary" class="el-icon-search" @click="inputChange()">		搜索	</el-button><el-button size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button></template>
			<el-form-item label="搜索：">
					<el-input size="small" @keyup.enter.native="inputChange" v-model="formInline.name"
						placeholder="请输入"></el-input>
				</el-form-item>
			</lcsj-filter> -->
			<STable
				:columns="columnsData"
				:data="listData"
				:loading="loading"
				:row-key="'keyId'"
				:tree-props="{ children: 'subList', hasChildren: 'hasChildren' }"
				:expand-row-keys="expandRowKeys"
				@get-data="getListData"
				@handle-command="handleCommand"
				@row-click="handleRowClick"
			></STable>
		</topTab>
		<!-- 编辑 -->
		<edit ref="edit"></edit>
	</div>
</template>

<script>
import { GetOrganizationTreeList } from "../../../api/organizationalApi.js";
import edit from "./edit";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "组织架构"
				}
			],
			pageShow: true,
			loading: false, // 显示加载
			expandAll: false,
			formInline: {
				name: ""
			},
			listData: [],
			columnsData: [], //显示列
			listColumns: [
				{
					prop: "name",
					label: "组织名称",
					isKeep: true
				},
				{
					prop: "remark2",
					label: "名称缩写"
				},
				// {
				// 	prop: "code",
				// 	label: "编号"
				// },
				// {
				// 	prop: "typeStr",
				// 	label: "组织类型"
				// },
				{
					prop: "personInCharge",
					label: "负责人"
				},
				{
					prop: "remark1",
					label: "联系电话"
				},
				{
					prop: "remark10",
					label: "区域经理"
				},
				{
					prop: "remark9",
					label: "三级负责人"
				},
				{
					prop: "remark8",
					label: "四级负责人"
				},
				{
					prop: "remark7",
					label: "财务负责人"
				},
				{
					prop: "descript",
					label: "组织描述"
				},
				{
					operation: true,
					isKeep: true,
					label: "操作",
					btnGroup: [
						{
							icon: "el-icon-plus",
							name: "新增",
							type: "1",
							btnType: ""
						}
					]
				}
			],
			expandRowKeys: []
		};
	},
	// 注册组件
	components: {
		edit
	},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.getListData();
	},
	computed: {},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		// 顶部tab页面切换
		changePages(tab) {},

		// 搜索框值变化
		inputChange() {
			this.getListData();
		},

		handleCommand(command) {
			switch (command.command) {
				case "1":
					this.addSubData(command.rowData);
					break;
				default:
					console.log(command);
			}
		},

		// 新增子表
		addSubData(row) {
			this.$refs.edit.editShow(row, 2);
		},

		// 单击行数据
		handleRowClick(row) {
			this.$refs.edit.editShow(row, 1);
		},

		// 重置
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.search();
		},

		// 搜索事件
		search() {
			this.getListData();
		},

		// 获取列表
		getListData() {
			this.listData = [];
			this.expandRowKeys = [];
			this.loading = true;
			GetOrganizationTreeList(this.formInline)
				.then((res) => {
					this.loading = false;
					if (res.code == 1) {
						this.listData = res.data;
						if (this.listData && this.listData.length > 0) {
							this.expandRowKeys.push(this.listData[0].keyId);
						}
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		}
	}
};
</script>

<style scoped>
.right {
	display: flex;
	flex-direction: row-reverse;
}
</style>
